/**
 * Слои строки создания на телефоне — записи в истории (ТЗ главной § 7): превью этапа 1, этап 2 и
 * меню модулей. Что открыто, выводится только из `location.state.composerLayers`: системная «Назад»
 * сама закрывает верхний слой. Чистые функции без alias-импортов — их проверяет
 * `tests/home-composer.test.ts`.
 */

export type ComposerLayer = 'preview' | 'choose' | 'modules';

const KNOWN: readonly ComposerLayer[] = ['preview', 'choose', 'modules'];

const isRecord = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

/** Слои из `location.state`: неизвестные значения и повторы отбрасываются. */
export function readComposerLayers(state: unknown): ComposerLayer[] {
  const raw = isRecord(state) ? state.composerLayers : undefined;
  if (!Array.isArray(raw)) return [];
  const out: ComposerLayer[] = [];
  for (const item of raw) {
    if ((KNOWN as readonly unknown[]).includes(item) && !out.includes(item as ComposerLayer)) out.push(item as ComposerLayer);
  }
  return out;
}

/** Стек со слоем сверху; слой уже открыт — null (вторую запись в истории не заводим). */
export function addComposerLayer(layers: readonly ComposerLayer[], layer: ComposerLayer): ComposerLayer[] | null {
  return layers.includes(layer) ? null : [...layers, layer];
}

/** Закрыть кнопкой можно только верхний слой: `navigate(-1)` снимает именно его. */
export function isTopLayer(layers: readonly ComposerLayer[], layer: ComposerLayer): boolean {
  return layers.length > 0 && layers[layers.length - 1] === layer;
}

/** Новое `location.state`: прочие ключи страницы сохраняются, меняются только слои. */
export function stateWithLayers(state: unknown, layers: readonly ComposerLayer[]): Record<string, unknown> {
  return { ...(isRecord(state) ? state : {}), composerLayers: [...layers] };
}
